module.exports = __webpack_public_path__ + "static/Remote Assistance-b58493d87f419886d30aa6d3a9d60f7a.svg";